<template>
  <div class="wrapper">
    <transition-group name="slide-fade">
      <notification-message
        v-for="notif in notifications"
        :key="notif.id"
        :notif="notif"
      />
    </transition-group>
  </div>
</template>

<script>
  import notificationMessage from './NotificatiMessage.vue';

  export default {
    // eslint-disable-next-line
    name: 'Notifications',
    components: { notificationMessage },
    computed: {
      notifications() {
        return this.$store.state.notification.notifications;
      },
    },
  };
</script>

<style scoped>
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .wrapper {
    display: flex;
    position: absolute;
    top: 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
    width: 100vw;
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 12px;
    border-radius: 11px;
    width: 100%;
    width: min(calc(100vw - 60px), 320px);
    height: 80px;
  }
  .red {
    background: var(--error);
  }
  .green {
    background: var(--success);
    color: var(--text);
  }
</style>
